var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseCard',[_c('BaseCardHeader',[_c('div',{staticClass:"leading-normal"},[_vm._v("Role info")])]),_c('BaseCardBody',[_c('span',{staticClass:"text-gray-600"},[_vm._v(" Description ")]),(_vm.role.description)?_c('h6',[_vm._v(" "+_vm._s(_vm.role.description)+" ")]):_c('h6',[_vm._v("-")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }